// extracted by mini-css-extract-plugin
export var checkbox = "style-module--checkbox--fd6d6";
export var checkboxLabel = "style-module--checkboxLabel--9104d";
export var checkboxRow = "style-module--checkboxRow--bb670";